<template>
  <template v-for="n in count" :key="n">
    <slot :index="n" />
  </template>
</template>

<script>
// Renders no wrapper element of its own — only the repeated slot content — so it can be
// dropped anywhere a fixed DOM structure is required (e.g. directly inside a <tbody>,
// where an extra wrapping <div> would be invalid HTML and break table layout). Pair with
// BaseSkeletonBar for the actual placeholder visual, or pass any other markup.
export default {
  name: 'BaseSkeleton',
  props: {
    count: {
      type: Number,
      required: false,
      default: 3
    }
  }
}
</script>
